import React from "react";
import PropTypes from "prop-types";

import styles from "./opening-hours.module.scss";

function OpeningHours({ openingHours }) {
  return (
    <div>
      {openingHours.length > 1 ? (
        <ul className={styles["opening-hours__multiline-availability"]}>
          {openingHours.map(({ days, times }) => (
            <li key={days} className={styles["opening-hours__availability-line"]}>
              <span className={styles["opening-hours__days"]}>{days}</span>
              <span className={styles["opening-hours__hours"]}>{times}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles["opening-hours__single-availability"]}>
          <span className={styles["opening-hours__days"]}>{openingHours[0].days}</span>
          <span className={styles["opening-hours__hours"]}>{openingHours[0].times}</span>
        </p>
      )}
    </div>
  );
}

OpeningHours.propTypes = {
  openingHours: PropTypes.arrayOf(PropTypes.any).isRequired,
};

OpeningHours.defaultProps = {};

export default OpeningHours;
